import React, { useState, useEffect } from 'react';

import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import { Link , useParams, useNavigate, useLocation  } from "react-router-dom";
import {Links} from '../../routes/PathLink';
import { useAllConcallsInfiniteQuery } from '../../data/concall-data';

import { useSiteSettings } from '../../contexts/site-settings/site-settings';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loaderanimation from 'components/ui/loaderanimation';
import {APP_URL, APP_NAME} from 'components/config/Common'
import Seo from 'components/seo/seo'
import Breadcrumb  from "../../components/Breadcrumb";
import { FaFilePdf, FaYoutube } from "react-icons/fa";
import { BiSolidVideoRecording } from "react-icons/bi";
import Input from '../../components/ui/input.jsx';
import { BsSearch } from "react-icons/bs";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

const AllConcalls = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const sq = queryParams.get('sq') || '';
    const { sitelogo } = useSiteSettings();

    const [searchQuery, setSearchQuery] = useState('');
    const [limit, setLimit] = useState(40);

    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        error,
    } = useAllConcallsInfiniteQuery({sq:searchQuery, limit: limit});

    const allConcalls = data ? data.pages.flatMap(page => page.data) : [];

    //console.log('all concalls==========:', data.pages[0]?.total, allConcalls.length);

    const breadcrumb = [
      {
        name:'Home',
        link:`${process.env.REACT_APP_URL}`,
      },
      {
        name:`All ConCalls`,
        link:null
      },
    ]

    const formatTime = (date) => {
      const now = dayjs();
      const postDate = dayjs(date);
      const diffInDays = now.diff(postDate, "day");
    
      // After 1 days show full date
      return postDate.format("MMM YYYY");
    };

    const searchSector = (val) => {
      //console.log('sq---', val)
      setSearchQuery(val)
    }

    return (
        <div>
            <Seo 
                title={`All Companies ConCalls - ${APP_NAME}`}
                desc={`Explore the latest concalls of all companies. Stay updated with the most recent earnings calls, financial discussions, and insights from various industries. Access comprehensive concall data and analysis to make informed investment decisions.`}
                url={`${APP_URL}/concalls`}
            />  
            <Header />
            <div className='px-5 md:px-8'>
                {<Breadcrumb breadcrumb={breadcrumb} />}
            </div>
            <div className='px-5 md:px-8 mt-5'>
            <section className="bg-white shadow-md z-50 rounded-xl p-5 mt-5">
                <div className="flex flex-row items-center justify-between gap-5 pb-5">
                    <h2 className="text-2xl font-semibold mt-3">ConCalls</h2>
                    <div className="relative">
                        <div className="absolute inset-y-0 left-0 top-3 flex items-center pl-3 pointer-events-none">
                        <BsSearch className="w-3 h-3 text-black" />
                        </div>
                        <Input 
                        dimension='small' 
                        onChange={(e) => searchSector(e.target.value)} 
                        value={searchQuery}
                        placeholder='Search ConCalls by name, symbol...'
                        inputClassName={"!h-8 !pl-8 !w-[50px] focus:!w-[200px] transition-[width] duration-300 ease-in-out" + (searchQuery ? " !w-[200px]" : " !w-[50px]")}
                        />
                    </div>
                </div>
                
                <div className='my-5'>Explore the latest concalls of all companies. Stay updated with the most recent earnings calls, financial discussions, and insights from various industries. Access comprehensive concall data and analysis to make informed investment decisions.</div>
                <InfiniteScroll
                    dataLength={allConcalls.length}
                    next={fetchNextPage}
                    hasMore={!!hasNextPage}
                    loader={<Loaderanimation />}
                    endMessage={data?.pages[0]?.total > limit &&
                        <p className="text-center mt-5 text-gray-500">
                            No more concalls to show
                        </p>
                    }
                >
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 py-5">
                        {allConcalls.map((val, index) => (
                            <div key={index} className="rounded-xl border border-gray-200 overflow-hidden transition duration-300 group">            
                                <div className="px-3 py-3 border-b border-gray-200">
                                <Link to={`${APP_URL}/company/${val?.symbol}`} className=" text-accent line-clamp-1" title={val?.security?.name} target="_blank">{val?.security?.name}</Link>
                                <div className="text-sm text-gray-500">{val?.symbol}</div>
                                </div>
                                <div className="flex items-center justify-between px-4 py-3 gap-3">
                                    <h2 className="text-md overflow-hidden">{formatTime(val?.concall_qtr)}</h2>
                                    <div className="flex items-center justify-center   gap-3">
                                        {val?.youtube_url && (
                                            <Link title="YouTube" to={val?.youtube_url} target="_blank" className="text-blue-600 hover:underline">
                                                <FaYoutube size={25} color="red" />
                                            </Link>
                                        )}
                                        {val?.doc_url && (
                                            <Link title="Document" to={val?.doc_url} target="_blank" className="text-blue-600 hover:underline">
                                                <FaFilePdf size={20} color="black" />
                                            </Link>
                                        )}
                                        {val?.recording_url && (
                                            <Link title="Recording" to={val?.recording_url} target="_blank" className="text-blue-600 hover:underline">
                                                <BiSolidVideoRecording size={25} className="text-accent" />
                                            </Link>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </InfiniteScroll>
            </section>
            </div>
            <Footer />
        </div>
    );
};

export default AllConcalls;